import { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const SearchReceipt = () => {
  debugger;
  const [currentDate, setCurrentDate] = useState("");
  const [cashReceiptData, setCashReceiptData] = useState("");
  const [updateCashReceiptDetails, setUpdateCashReceiptData] = useState("");
  const [fromYear, setFromYear] = useState("");
  const [toYear, setToYear] = useState("");
  const [selectedYears, setSelectedYears] = useState(0);
  const [bookNo, setBookNo] = useState("");
  const [fee, setFee] = useState("");
  const [searchType, setSearchType] = useState("");
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    prtname: "",
    prt2name: "",
    property_detail: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    prtname: false,
    prt2name: false,
    property_detail: false,
  });
  const location = useLocation();
  const { regYear, vol, sr, typeRecpt, mod } = location.state || {};
  console.log("updateCashReceiptDetails", updateCashReceiptDetails);
  const navigate = useNavigate();

  const { userDetails } = useSelector((state) => state.auth);

  console.log("userDetails", userDetails.dcode);

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getDate()}/${
      today.getMonth() + 1
    }/${today.getFullYear()}`;
    setCurrentDate(formattedDate);
  }, []);

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1949 }, (_, i) => 1950 + i);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
    // Clear validation error when the user starts typing
    setValidationErrors((prev) => ({
      ...prev,
      [id]: false,
    }));
  };
  const handleYearChange = () => {
    if (!fromYear || !toYear) return;

    const from = parseInt(fromYear, 10);
    const to = parseInt(toYear, 10);

    if (from > to) {
      alert("To year should not be less than From year.");
      setFromYear("");
      setToYear("");
      setFee("");
      setSelectedYears(0);
      return;
    }

    const yearsCount = to - from + 1;
    setSelectedYears(yearsCount);

    let calculatedFee = 0;

    if (bookNo === "3" || bookNo === "4") {
      calculatedFee = Math.min(5 * yearsCount, 100);
    } else if (searchType === "0") {
      calculatedFee = Math.min(5 * yearsCount, 25);
    } else if (searchType === "1") {
      calculatedFee = 20 * yearsCount;
    } else if (searchType === "2") {
      calculatedFee = 20 * yearsCount + 5;
    }

    setFee(calculatedFee);
  };

  const fetchCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/get_details_Virtual_Load_Cashreceipt_Sp/${userDetails.dcode}/${userDetails.srocode}/0/receipt_search`
      );

      if (response.data.statusResponse.statusCode === 200) {
        setCashReceiptData(response.data.cashReceiptDetails);
        setEditMode(false);
      } else {
        setError("No data found");
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchCashReceiptDetails();
  // }, []);

  const fetchUpdateCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/GetReceiptModification/${userDetails.dcode}/${userDetails.srocode}/${vol}/${sr}/${regYear}`
      );

      setUpdateCashReceiptData(response.data[0]);
      setEditMode(true);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    debugger;
    if (typeRecpt === "Search" && mod === true) {
      fetchUpdateCashReceiptDetails();
    } else {
      fetchCashReceiptDetails();
    }
  }, [typeRecpt, mod]); // Dependency array ensures this runs when typeRecpt changes
  useEffect(() => {
    if (editMode && updateCashReceiptDetails) {
      setFormData({
        prtname: updateCashReceiptDetails.appName || "",
        prt2name: updateCashReceiptDetails.appAdd || "",
        property_detail: updateCashReceiptDetails.propDetail || "",
      });
      setBookNo(updateCashReceiptDetails.talashBook || "");
      setFromYear(updateCashReceiptDetails.yearFrom || "");
      setToYear(updateCashReceiptDetails.yearTo || "");
      setSearchType(updateCashReceiptDetails.mode || "");
      setFee(updateCashReceiptDetails.miscFee || "");
    }
  }, [updateCashReceiptDetails, editMode]);

  // const handleSave = async () => {
  //   const errors = {};

  //   if (!fee) {
  //     if (!searchType) {
  //       errors.searchType = "Please Select Receipt Type";
  //     } else if (!bookNo) {
  //       errors.bookNo = "Please Select Book No";
  //     } else if (!fromYear) {
  //       errors.fromYear = "Please Select fromYear";
  //     } else if (!toYear) {
  //       errors.toYear = "Please Select toYear";
  //     }
  //   } else if (!formData.prtname) {
  //     errors.prtname = "Please fill Applicant Name";
  //   } else if (!formData.prt2name) {
  //     errors.prt2name = "Please fill Applicant Address";
  //   } else if (!formData.property_detail) {
  //     errors.property_detail = "Please fill Property details";
  //   }

  //   // If there are errors, set validation state and show first error message
  //   if (Object.keys(errors).length > 0) {
  //     setValidationErrors(errors);
  //     toast.error(Object.values(errors)[0]); // Show only the first error
  //     return;
  //   }

  //   try {
  //     const payload = {
  //       dcode: userDetails.dcode,
  //       srocode: userDetails.srocode,
  //       pimode: "receipt_search",
  //       tokenno: bookNo,
  //       misc_fee: fee || 100,
  //       code: selectedYears,
  //       fyear: fromYear || 0,
  //       tyear: toYear || 0,
  //       nakalown: "string",
  //       nakalregdate: "string",
  //       nakalcopy: "0",
  //       mode: searchType,
  //       prtname: formData.prtname,
  //       prt2name: formData.prt2name,
  //       property_detail: formData.property_detail,
  //     };

  //     const response = await axios.post(
  //       `${API_BASE_URL}/CashReceipt/Insert_Cashreceipt_Sp`,
  //       payload, // Send as JSON instead of FormData
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.status === 200 && response.data) {
  //       debugger
  //       console.log("API Response:", response.data);
  //       setPrintData(response.data.response)
  //       fetchCashReceiptDetails();
  //       toast.success("Fees Submitted Successfully");

  //       // Reset form fields
  //       setFormData({
  //         prtname: "",
  //         prt2name: "",
  //         property_detail: "",
  //       });
  //       setBookNo("");
  //       setFromYear("");
  //       setToYear("");
  //       setSearchType("");
  //       setFee("");
  //     } else {
  //       throw new Error("Not found");
  //     }
  //   } catch (err) {
  //     console.error("Error in Insert Search Receipt API:", err);
  //     toast.error("Contact IT Cell");
  //   }
  // };

  const CashReceiptReportLink = (printData) => {
    debugger;
    return `${REPORT_BASE_URL}/Report/CashReceiptReports.aspx?dcode=${
      userDetails.dcode
    }&srocode=${userDetails.srocode}&vol=${printData.vol}&sr=${
      printData.sr
    }&year=${
      printData.regYear
    }&recptDate=${currentDate}&tdate=${currentDate}&mode=receipt&mode1=${"search"}`;
  };
  const handleSave = async () => {
    const errors = {};

    if (!fee) {
      if (!searchType) {
        errors.searchType = "Please Select Receipt Type";
      } else if (!bookNo) {
        errors.bookNo = "Please Select Book No";
      } else if (!fromYear) {
        errors.fromYear = "Please Select fromYear";
      } else if (!toYear) {
        errors.toYear = "Please Select toYear";
      }
    } else if (!formData.prtname) {
      errors.prtname = "Please fill Applicant Name";
    } else if (!formData.prt2name) {
      errors.prt2name = "Please fill Applicant Address";
    } else if (!formData.property_detail) {
      errors.property_detail = "Please fill Property details";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]);
      return;
    }

    try {
      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_search",
        tokenno: bookNo,
        misc_fee: fee || 100,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "string",
        nakalcopy: "0",
        mode: searchType,
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        property_detail: formData.property_detail,
      };

      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Insert_Cashreceipt_Sp`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;
        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");

        // Generate the report URL
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");

        // Reset form fields
        setFormData({ prtname: "", prt2name: "", property_detail: "" });
        setBookNo("");
        setFromYear("");
        setToYear("");
        setSearchType("");
        setFee("");
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Insert Search Receipt API:", err);
      toast.error("Contact IT Cell");
    }
  };

  const handleUpdate = async () => {
    const errors = {};

    if (!fee) {
      if (!searchType) {
        errors.searchType = "Please Select Receipt Type";
      } else if (!bookNo) {
        errors.bookNo = "Please Select Book No";
      } else if (!fromYear) {
        errors.fromYear = "Please Select fromYear";
      } else if (!toYear) {
        errors.toYear = "Please Select toYear";
      }
    } else if (!formData.prtname) {
      errors.prtname = "Please fill Applicant Name";
    } else if (!formData.prt2name) {
      errors.prt2name = "Please fill Applicant Address";
    } else if (!formData.property_detail) {
      errors.property_detail = "Please fill Property details";
    }

    // If there are errors, set validation state and show first error message
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]); // Show only the first error
      return;
    }
    try {
      const formData2 = new FormData();
      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_search",
        tokenno: bookNo,
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        misc_fee: fee || 100,
        code: selectedYears,
        property_detail: formData.property_detail,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "string",
        nakalcopy: "0",
        mode: "string",
        vol: updateCashReceiptDetails?.vol || "",
        sr: updateCashReceiptDetails?.sr || "",
        epayment_rfee: updateCashReceiptDetails?.epayment_rfee || "",
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });

      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Update_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;

        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");

        // Generate the report URL
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        navigate("/ModifyReciept");
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Update Search Receipt API:", err);
      alert("Error occurred while updating the receipt.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
          {/* Left Side */}
          <div className="flex-1 p-2 md:p-4">
            <div className="p-4 md:p-8 bg-gray-100 min-h-screen">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
                New Receipt - Search Receipt
              </h1>

              <div className="bg-white p-4 md:p-6 space-y-4">
                <div className="flex flex-wrap gap-2 md:gap-6 items-center justify-center md:justify-start">
                  <div className="text-center md:text-left">
                    <b>Date: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.recptDate
                        : currentDate}
                    </span>
                  </div>
                  <div className="text-center md:text-left">
                    <b>Cash Receipt: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.sr
                        : cashReceiptData.sr}
                    </span>
                  </div>
                  <div className="text-center md:text-left">
                    <b>Vol no: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.vol
                        : cashReceiptData.vol}
                    </span>
                  </div>
                  <div className="text-center md:text-left">
                    <b>Application no: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.srno
                        : cashReceiptData.srno}
                    </span>
                  </div>
                  <div className="text-center md:text-left">
                    <b>Crt no: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.appliNo
                        : cashReceiptData.applino}
                    </span>
                  </div>
                  <div className="text-center md:text-left">
                    <b>Fee: </b>
                    <span>
                      {editMode ? updateCashReceiptDetails.miscFee : fee}
                    </span>
                  </div>
                </div>

                {/* Form Section */}
                <div className="space-y-4 mt-4">
                  {/* Receipt Type */}
                  <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4">
                    <div className="space-y-2">
                      <span className="font-bold block">
                        Select Receipt Type:
                      </span>
                      <div className="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-4">
                        {["0", "1", "2"].map((type) => (
                          <label
                            key={type}
                            className="flex items-center space-x-2"
                          >
                            <input
                              type="radio"
                              value={type}
                              checked={searchType === type}
                              onChange={(e) => setSearchType(e.target.value)}
                              className="w-4 h-4 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <span>
                              {type === "0"
                                ? "Ordinary"
                                : type === "1"
                                ? "Urgent"
                                : "Most Urgent"}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="flex-1">
                      <label className="block font-bold mb-1">
                        Select Book no.
                      </label>
                      <select
                        value={
                          editMode
                            ? updateCashReceiptDetails.talashBook
                            : bookNo
                        }
                        onChange={(e) => setBookNo(e.target.value)}
                        className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="">Select</option>
                        <option value="1">1</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="6">6</option>
                      </select>
                    </div>

                    <div className="flex-1">
                      <label className="block font-bold mb-1">From Year</label>
                      <select
                        // value={fromYear}
                        value={
                          editMode
                            ? updateCashReceiptDetails.yearFrom
                            : fromYear
                        }
                        onChange={(e) => setFromYear(e.target.value)}
                        className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="">Select Year</option>
                        {generateYears().map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex-1">
                      <label className="block font-bold mb-1">To Year</label>
                      <select
                        value={
                          editMode ? updateCashReceiptDetails.yearTo : toYear
                        }
                        onChange={(e) => setToYear(e.target.value)}
                        onBlur={handleYearChange}
                        className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="">Select Year</option>
                        {generateYears().map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Text Inputs */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="prtname"
                        type="text"
                        value={formData.prtname}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prtname
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prtname"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Applicant Name
                      </label>
                    </div>
                  </div>

                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="prt2name"
                        type="text"
                        value={formData.prt2name}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prt2name
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prt2name"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Applicant Address
                      </label>
                    </div>
                  </div>

                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="property_detail"
                        type="text"
                        value={formData.property_detail}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.property_detail
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="property_detail"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Details Of Property
                      </label>
                    </div>
                  </div>

                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="authorizedPerson"
                        type="text"
                        value="Self"
                        className={`w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 border-[#B1B1B1] peer`}
                        placeholder=""
                        readOnly
                      />
                      <label
                        htmlFor="Person"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Authorized Person
                      </label>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="col-span-1 md:col-span-1 md:col-end-3">
                    <button
                      onClick={editMode ? handleUpdate : handleSave}
                      className="w-full bg-blue-400 text-white px-6 py-2 rounded hover:bg-blue-700 focus:outline-none"
                    >
                      {editMode ? "UPDATE" : "SAVE"}
                    </button>
                  </div>
                  <div className="col-span-1 md:col-span-1 md:col-end-4">
                    <button className="w-full text-[#DA0000] px-6 py-2 border border-[#DA0000] rounded hover:bg-red-100 focus:outline-none">
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="w-full md:w-64 h-full">
            <UserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchReceipt;
